import api from "@/api/v1-jwt/config/api";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import { createErrorHandler } from "@/utils/errorHandler";
import { SweepsEntity, SweepsPayload, sweepsPayloadSchema } from "../types";
import sweepQueryKeys from "../query-keys";
import { z } from "zod";

type SweepsCreateParams = { userId: string; payload: SweepsPayload };

const sweepSettingsCreateFn = async ({
  userId,
  payload,
}: SweepsCreateParams): Promise<SweepsEntity> => {
  sweepsPayloadSchema.parse(payload);
  const url = `/platform/sweeps/setting/${userId}`;
  const response = await api.post<SweepsPayload>(url, payload);
  return z.any().parse(response.data);
};

export const sweepSettingsCreate = {
  createOptions: (
    options?: UseMutationOptions<SweepsEntity, Error, SweepsCreateParams>
  ) => {
    const queryClient = useQueryClient();
    const defaultOptions: UseMutationOptions<
      SweepsEntity,
      Error,
      SweepsCreateParams
    > = {
      mutationFn: sweepSettingsCreateFn,
      onSuccess: () => queryClient.invalidateQueries(sweepQueryKeys.all),
      onError: createErrorHandler({
        customHandlers: {
          400: () => "Sweeps has already been processed",
        },
      }),
    };
    return { ...defaultOptions, ...options };
  },
  useMutation: (
    options?: UseMutationOptions<SweepsEntity, Error, SweepsCreateParams>
  ) => {
    const mutationOptions = sweepSettingsCreate.createOptions(options);
    return useMutation<SweepsEntity, Error, SweepsCreateParams>(
      mutationOptions
    );
  },
};
